// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../tokens/typography.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*@import 'src/tokens/index.css';*/
/*@import 'src/tokens/spacing.css';*/
/*@import 'src/tokens/shapes.css';*/

:host {
    display: block;
}
header {
    align-items: center;
    background-color: var(--background-white);
    /*border-bottom: 1px solid var(--border-strong);*/
    display: flex;
    padding-left: var(--custom-spacing-30);
    padding-right: var(--custom-spacing-30);
    position: relative;
    /*height: var(--spacing-60);*/
    /* 80px as swift.com instead of 48px as the design system*/
    height: var(--spacing-100);
}

header a {
    /*swift.com overrides*/
    margin-right: 80px;
}
header img,
header a {
    height: var(--logo-m-heigth);
    width: var(--logo-m-width);
}

header .links {
    display: flex;
    align-items: center;
    position: absolute;
    right: var(--custom-spacing-30);
}
header .links swiftref-button {
    margin-left: var(--spacing-15);
}


/*same as swift.com*/
@media (max-width: 940px) {
    :host {
        position: sticky;
        top: 0;
        z-index: 1;
        /*box-shadow: 0 0 10px rgba(51,61,62,.1);*/
    }
    header {
        height: 70px;
    }
    header img,
    header a {
        height: var(--logo-s-heigth);
        width: var(--logo-s-width);
    }
}

`, "",{"version":3,"sources":["webpack://./../website_design_system/src/components/header/style/index.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC,oCAAoC;AACpC,mCAAmC;;AAGnC;IACI,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,yCAAyC;IACzC,iDAAiD;IACjD,aAAa;IACb,sCAAsC;IACtC,uCAAuC;IACvC,kBAAkB;IAClB,6BAA6B;IAC7B,0DAA0D;IAC1D,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;AACA;;IAEI,4BAA4B;IAC5B,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,+BAA+B;AACnC;AACA;IACI,8BAA8B;AAClC;;;AAGA,oBAAoB;AACpB;IACI;QACI,gBAAgB;QAChB,MAAM;QACN,UAAU;QACV,0CAA0C;IAC9C;IACA;QACI,YAAY;IAChB;IACA;;QAEI,4BAA4B;QAC5B,0BAA0B;IAC9B;AACJ","sourcesContent":["/*@import 'src/tokens/index.css';*/\n/*@import 'src/tokens/spacing.css';*/\n/*@import 'src/tokens/shapes.css';*/\n@import 'src/tokens/typography.css';\n\n:host {\n    display: block;\n}\nheader {\n    align-items: center;\n    background-color: var(--background-white);\n    /*border-bottom: 1px solid var(--border-strong);*/\n    display: flex;\n    padding-left: var(--custom-spacing-30);\n    padding-right: var(--custom-spacing-30);\n    position: relative;\n    /*height: var(--spacing-60);*/\n    /* 80px as swift.com instead of 48px as the design system*/\n    height: var(--spacing-100);\n}\n\nheader a {\n    /*swift.com overrides*/\n    margin-right: 80px;\n}\nheader img,\nheader a {\n    height: var(--logo-m-heigth);\n    width: var(--logo-m-width);\n}\n\nheader .links {\n    display: flex;\n    align-items: center;\n    position: absolute;\n    right: var(--custom-spacing-30);\n}\nheader .links swiftref-button {\n    margin-left: var(--spacing-15);\n}\n\n\n/*same as swift.com*/\n@media (max-width: 940px) {\n    :host {\n        position: sticky;\n        top: 0;\n        z-index: 1;\n        /*box-shadow: 0 0 10px rgba(51,61,62,.1);*/\n    }\n    header {\n        height: 70px;\n    }\n    header img,\n    header a {\n        height: var(--logo-s-heigth);\n        width: var(--logo-s-width);\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
